/** @format */

import React, { FunctionComponent, ReactElement, useState } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import SimCardInterface from '../../interfaces/platform/SimCardInterface';
import GridItem from '../../components/Grid/GridItem';
import Switch from '@material-ui/core/Switch';
import I18n from '../../components/Translate/I18n';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useDispatch } from 'react-redux';
import { CustomInputCurrency } from '../../components/CustomInput/CustomInputCurrency';
import ActionButton from '../../components/Buttons/CustomTextButton';
import AlertInfo from '../../components/Info/AlertInfo';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import MvnoBlockRequest from '../../interfaces/platform/MvnoBlockRequest';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';

type UnitLimitType = {
    product: SimCardInterface;
    refreshPage: () => void;
};

export const UnitLimit: FunctionComponent<UnitLimitType> = ({ product, refreshPage }): ReactElement => {
    const dispatch = useDispatch();
    const [singleActive, setSingleActive] = useState(product.unitLimit);
    const [unitValue, setUnitValue] = useState(product.unitLimitValue);
    const [saveButton, setSaveButton] = useState(false);
    const [alert, setAlert] = useState<any | null>(null);

    const onCheckBoxEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const name = event.target.name;
        const value = event.target.value;
        const checked = event.target.checked;
        setSingleActive(checked);
        if (product.unitLimit !== checked) {
            setSaveButton(true);
        } else {
            setSaveButton(false);
        }
    };

    const onNumberEvent = (field: string, value: number | null): void => {
        const setValue = value || value === 0;
        if (setValue) {
            setSaveButton(true);
            setUnitValue((value ?? 0) * 100);
            return;
        }
        setSaveButton(false);
    };

    const activateFeatureConfirm = (): void => {
        setAlert(
            <AlertInfo
                onConfirm={activateCallApi}
                onCancel={(): void => setAlert(null)}
                confirmBtnText={'simcard:f.save_change'}
                cancelBtnText={'general:common.cancel'}
                content={'simcard:f.confirm_change_single_premium_limit'}
            />
        );
    };

    const activateCallApi = (): void => {
        const itemLoader = new ItemLoaders(dispatch);
        let params = '{}';
        let operation = 'OperationPremiumLimit110408Deactivate';
        if (singleActive) {
            params = JSON.stringify({ componentParams: [{ name: 'kwo_limit', value: unitValue ?? 0 }] });
            operation = 'OperationPremiumLimit110408';
        }
        itemLoader.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_requests')),
            'mvno_block_requests_activate_unit_limit',
            {
                mvnoBlockListName: operation,
                simCardId: product.id,
                params: params,
            },
            (response: MvnoBlockRequest) => {
                setAlert(null);
                refreshPage();
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    return (
        <GridContainer>
            <GridItem xs={12}>
                <FormControlLabel
                    disabled={UserRoleHelper.checkRole(roles.ROLE_SUBSCRIPTION_VIEW_ONLY)}
                    control={<Switch checked={singleActive} onChange={onCheckBoxEvent} value="premiumLimitSingleSwitch" />}
                    label={<I18n trans="simcard:f.premium_limit_single" />}
                />
            </GridItem>
            {singleActive && (
                <GridItem xs={12}>
                    <CustomInputCurrency
                        formControlProps={{
                            fullWidth: true,
                        }}
                        labelText="simcard:f.premium_limit_single_amount"
                        onChangeEvent={onNumberEvent}
                        value={(unitValue ?? 0) / 100}
                    />
                </GridItem>
            )}
            {saveButton && (
                <GridItem xs={12} style={{ paddingTop: 15 }}>
                    <ActionButton callback={activateFeatureConfirm} callbackParam={{}} label="simcard:f.save_premium_limit" size="sm" />
                    {alert}
                </GridItem>
            )}
        </GridContainer>
    );
};
